import React, { useEffect, useRef, useState } from 'react';
import { Button, CustomInput } from 'reactstrap';
import {
  productEditingModes,
  ProductImageStatus,
} from '../../constants/productApproval';
import productAPI from '../../services/API/product';
import { NotificationManager } from '../common/react-notifications';
import { ImageSelector } from './ImageSelector';
import { ProductImage } from './ProductImage';

export const ProductImages = ({
  productId,
  editingMode,
  onImagesChanged,
  isAllowAddImage,
  imageAddError,
  isSM,
}) => {
  const [images, setImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(false);
  const primaryRefSet = useRef(false);

  const isMountedRef = useRef(true);
  const shouldSyncWithRemote =
    editingMode !== productEditingModes.ADD_NEW && !!productId;

  useEffect(() => {
    const shouldLoadImages =
      editingMode !== productEditingModes.ADD_NEW && !!productId;
    if (shouldLoadImages) loadProductImages();
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (onImagesChanged) {
      console.log('why', images);
      onImagesChanged(images);
    }
  }, [images]);

  const loadProductImages = () => {
    setLoadingImages(true);

    productAPI
      .getProductImages(productId)
      .then((data) => {
        if (!isMountedRef.current) return;
        setImages(bringPrimaryToFirst(data));
      })
      .catch(() => {
        NotificationManager.error({
          message: 'Something went wrong! Please try again!',
        });
      })
      .finally(() => {
        if (!isMountedRef.current) return;
        setLoadingImages(false);
      });
  };

  const handleDeleteImage = (id) => {
    let newImages = images.filter((img) => img.id !== id);
    if (newImages.length && !newImages[0].img_primary)
      newImages[0].img_primary = true;
    setImages(newImages);

    if (shouldSyncWithRemote) {
      productAPI
        .deleteProductImage(id)
        .then((data) => {
          if (data.success) {
            NotificationManager.success({
              message: 'Image Removed',
            });
          } else {
            NotificationManager.error({
              message: data?.message || 'Something went wrong!',
            });
          }
        })
        .catch(() => {
          NotificationManager.error({
            message: 'Something went wrong! Please try again!',
          });
        });
    } else {
    }
  };

  const bringPrimaryToFirst = (imgs) =>
    imgs.sort((x, y) => y.img_primary - x.img_primary);

  const handleSetImagePrimary = (id) => {
    let newImages = images.map((img) => {
      img.img_primary = img.id === id;
      return img;
    });
    setImages(bringPrimaryToFirst(newImages));

    if (shouldSyncWithRemote) {
      productAPI
        .setPrimaryImage({
          image_id: id,
          product_id: productId,
        })
        .then((data) => {
          if (data.success) {
            NotificationManager.success({
              message: 'Image Set Primary',
            });
          } else {
            const errorMessage = data?.message ?? null;
            const errMsg =
              errorMessage && typeof errorMessage === 'string'
                ? errorMessage
                : 'Something went wrong!';
            NotificationManager.error({
              message: errMsg,
            });
          }
        })
        .catch(() => {
          NotificationManager.error({
            message: 'Something went wrong! Please try again!',
          });
        });
    }
  };

  const updateImageData = (id, update) => {
    setImages((oldImages) =>
      oldImages.map((oldImage) => {
        if (oldImage.id === id) {
          return {
            ...oldImage,
            ...update,
          };
        }
        return oldImage;
      })
    );
  };

  const uploadImage = async (newImage) => {
    productAPI
      .uploadImage(newImage)
      .then(({ img_url }) => {
        let isPrimary = !primaryRefSet.current;
        if (isPrimary) primaryRefSet.current = true;
        console.log('This', {
          status: ProductImageStatus.UPLOADED,
          img_primary: isPrimary,
          url: img_url,
        });
        updateImageData(newImage.id, {
          status: ProductImageStatus.UPLOADED,
          img_primary: isPrimary,
          url: img_url,
        });
        return img_url;
      })
      .then((imageUrl) => {
        // add the image here
        if (shouldSyncWithRemote) {
          productAPI.addProductImages(productId, [imageUrl]);
        }
      })
      .catch((err) => {
        console.log('Error', err);
        updateImageData(newImage.id, {
          status: ProductImageStatus.UPLOAD_FAILED,
        });
      });
  };

  const handleAddImage = (imageFiles) => {
    let newImages = imageFiles.map((imgFile) => ({
      ...imgFile,
      img_url: imgFile.uri,
      status: ProductImageStatus.UPLOADING,
      progress: 0,
    }));
    setImages([...images, ...newImages]);

    for (let newImage of newImages) {
      uploadImage(newImage);
    }
  };

  const imagesComponent =
    // images.length > 0 ? (
    images.map((image, index) => (
      <ProductImage
        key={`image_${index}`}
        image={image}
        index={index}
        onSetPrimary={handleSetImagePrimary}
        onDeleteImage={handleDeleteImage}
        isAllowAddImage={isAllowAddImage}
      />
    ));
  // ) : (
  //   <span style={{ fontSize: '1rem', fontFamily: 'Brown', fontWeight: 500 }}>
  //     No images uploaded
  //   </span>
  // )

  const allowAddImage = editingMode !== productEditingModes.EDIT_EXISTING;

  return (
    <div className='product-images-wrapper'>
      {/* <div className='pd-section-header '>
        <div className='pd-section-title'>
          <h3 style={{color: '#C98B76', fontFamily: 'Brown'}}>Images</h3>
        </div>
      </div> */}

      {allowAddImage && (
        <span
          className={`d-block ${isSM && 'mb-2'}`}
          style={{
            fontSize: 15,
            lineHeight: 1.73,
            marginBottom: isSM ? 20 : null,
          }}
        >
          Add 2-6 images of your item to give others a better idea of what is
          looks like. We highly recommend including pictures of you wearing your
          item to show how it fits and how you style it! Please include pictures
          of any stains, rips, damages or areas of general wear and tear.
        </span>
      )}

      <div className='mt-2 mb-2 d-flex product-imgs-lst '>
        {loadingImages
          ? 'Loading...'
          : !allowAddImage && images.length === 0
          ? 'No images'
          : imagesComponent}
        {!loadingImages &&
          allowAddImage &&
          images.length <= 5 &&
          isAllowAddImage && (
            <ImageSelector
              onImagesSelected={handleAddImage}
              imageAddError={imageAddError}
            />
          )}
      </div>
    </div>
  );
};
